<template lang="html">
  <span>
    <b-img
      v-show="loaded"
      :src="imgSrc"
      :fluid="fluid"
      :thumbnail="thumbnail"
      :width="width"
      :height="height"
      :style="returnStyle"
      @error="imgError"
      @load="imgLoad"
    />
    <b-img
      v-show="!loaded"
      :width="120"
      :height="120"
      :style="returnStyle"
      blank
      blank-color="#666"
      thumbnail
    />
  </span>
</template>

<script>
export default {
  name: "ReloadingImage",
  props: {
    src: {
      type: String,
      default: () => ""
    },
    fluid: {
      type: Boolean,
      default: () => false
    },
    thumbnail: {
      type: Boolean,
      default: () => false
    },
    width: {
      type: Number,
      default: () => null
    },
    height: {
      type: Number,
      default: () => null
    },
    max_height: {
      type: Number,
      default: () => null
    },
    reloadLimit: {
      type: Number,
      default: () => 3
    }
  },
  data() {
    return {
      version: 0,
      reloadTimeoutMs: 2500,
      loaded: false
    };
  },
  computed: {
    imgSrc() {
      return this.src + "?" + this.version;
    },
    returnStyle() {
      if (this.max_height) {
        return { "max-height": this.max_height + "px" };
      } else {
        return {};
      }
    }
  },
  methods: {
    imgError() {
      if (this.version >= this.reloadLimit) {
        return false;
      }
      setTimeout(() => {
        this.version++;
      }, this.reloadTimeoutMs);
    },
    imgLoad() {
      console.log("image loaded");
      this.loaded = true;
      this.$emit("load", this.src);
    }
  }
};
</script>

<style lang="css" scoped></style>
